import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js")